module.exports = __webpack_public_path__ + "img/f58b06d.jpg";